<template>
  <div>
    免费发布
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>